<header>
    <div class="container-header">
        <div class="logo"> 
            <a routerLink="/home"> 
                <img class="logo-auth" src="assets/images/logo-ats.png" alt="Logo ATS" />
            </a>
        </div>
    </div>
</header>

<div class="content-not-found">
   <div class="informacoes">
      <h1>404</h1>
      <h2>Página Não Encontrada</h2>
      <p>A página que você está procurando não existe.</p>
    
      <div class="linhas">
          <span></span>
          <span></span>
          <span></span>
      </div>
    
      <a routerLink="/home">Voltar para a tela inicial</a>
   </div>
</div>